<template>
	<wt-selector :options="options" v-model="Value" :disabled="disabled" :allow-create="true" :filterable="true" :props="props" :clearable="true" ></wt-selector>
</template>
<script>
export default {
  name: 'position-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: [],
      props: {
        value: 'id',
        label: 'name'
      },
      isAdd: true
    }
  },
  watch: {
    value (val) {
      this.isAdd = false
      this.Value = val
    },
    Value (val) {
      let isAdd = true
      this.$emit('input', this.Value)
      this.options.forEach(item => {
        if (item.id === val) {
          isAdd = false
          this.$emit('input', this.Value)
        }
      })
      if (isAdd && val && this.isAdd) {
        this.createItem(val)
      }
    }
  },
  methods: {
    createItem (val) {
      let params = {
        name: val,
        value: val
      }
      this.$store.dispatch('createPosition', params).then(data => {
        this.getList(data.id)
        this.$message.success('新建职位成功')
      }).catch(err => {
        this.$message.error(err || '新建职位失败')
      })
    },
    getList (addId) {
      this.$store.dispatch('getPosition').then(data => {
        this.options = data
        if (addId) {
          this.$nextTick(_ => {
            this.$emit('input', addId)
          })
        }
        this.$emit('positionList', data)
      }).catch(err => {
        this.$message.error(err || '获取职位列表失败')
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>
